import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SideNavWrapper, NavItem, LogoContainer, LogoImage, ToggleButtonContainer, ToggleButton } from '../styles/SideNav.styles';
import eduventraLogoNoText from '../data/eduventra_logo_notext-removebg.png';
import { useState } from 'react';

const SideNav = ({ teamId }) => {
    const location = useLocation();
    const activeTab = location.pathname;

    const [collapsed, setCollapsed] = useState(false);

    const toggleSidebar = () => setCollapsed((prev) => !prev);

    return (
        <SideNavWrapper collapsed={collapsed}>
            <ToggleButtonContainer>
                <ToggleButton onClick={toggleSidebar}>
                    {collapsed ? '+' : '−'}
                </ToggleButton>
            </ToggleButtonContainer>

            {!collapsed && (
                <>
                    <LogoContainer>
                        <LogoImage src={eduventraLogoNoText} alt="Eduventra Logo" />
                    </LogoContainer>

                    <Link to={`/${teamId}/home`} style={{ width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/home`}>Home</NavItem>
                    </Link>

                    <Link to={`/${teamId}/task-description`} style={{ textDecoration: 'none', width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/task-description`}>Task Description</NavItem>
                    </Link>

                    <Link to={`/${teamId}/cuban-bike-market`} style={{ textDecoration: 'none', width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/cuban-bike-market`}>Cuban Bike Market</NavItem>
                    </Link>

                    <Link to={`/${teamId}/population-preferences`} style={{ textDecoration: 'none', width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/population-preferences`}>Population and Preferences</NavItem>
                    </Link>

                    <Link to={`/${teamId}/segment-preference-index`} style={{ textDecoration: 'none', width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/segment-preference-index`}>Population size and Preference Overview</NavItem>
                    </Link>

                    <Link to={`/${teamId}/segment-information-by-tier`} style={{ textDecoration: 'none', width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/segment-information-by-tier`}>Advertising Cost by Audience</NavItem>
                    </Link>

                    <Link to={`/${teamId}/decision-tool`} style={{ textDecoration: 'none', width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/decision-tool`}>Play Round 1</NavItem>
                    </Link>

                    <Link to={`/${teamId}/decision-tool-2`} style={{ textDecoration: 'none', width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/decision-tool-2`}>Play Round 2</NavItem>
                    </Link>

                    <Link to={`/${teamId}/decision-tool-3`} style={{ textDecoration: 'none', width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/decision-tool-3`}>Play Round 3</NavItem>
                    </Link>

                    <Link to={`/${teamId}/results`} style={{ textDecoration: 'none', width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/results`}>My Results</NavItem>
                    </Link>

                    <Link to={`/${teamId}/ventra`} style={{ textDecoration: 'none', width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/ventra`}>Ventra AI</NavItem>
                    </Link>

                    <Link to={`/${teamId}/faq`} style={{ textDecoration: 'none', width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/faq`}>FAQ</NavItem>
                    </Link>

                    <Link to={`/${teamId}/feedback`} style={{ textDecoration: 'none', width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/feedback`}>Feedback</NavItem>
                    </Link>

                    <Link to={`/`} style={{ textDecoration: 'none', width: '100%' }}>
                        <NavItem active={activeTab === `/${teamId}/sign-out`}>Sign Out</NavItem>
                    </Link>
                </>
            )}
        </SideNavWrapper>
    );
};

export default SideNav;
